import type { FieldPath, FieldValues } from 'react-hook-form'
import type { Style } from 'inlines'
import type { SearchSelectOption } from '@app/components/core/input/searchSelect/SearchSelect'
import { FormField } from '../FormField'
import { useFieldRequired } from '../formSchemaContext'
import {
  RegionSelector,
  type RegionSelectorProps,
} from '@app/components/blocks/smartInputs/RegionSelector'

export type RegionSelectorFieldProps<T extends FieldValues = FieldValues> = {
  name: FieldPath<T>
  label?: string
  labelStyle?: Style
  required?: boolean
  style?: Style
} & Omit<RegionSelectorProps, 'region' | 'setRegion' | 'required' | 'errorMessage'>

export const RegionSelectorField = <T extends FieldValues = FieldValues>({
  name,
  required,
  ...props
}: RegionSelectorFieldProps<T>) => {
  const fieldRequired = useFieldRequired(name)
  const isRequired = required ?? fieldRequired

  return (
    <FormField<T>
      name={name}
      render={({ value, onChange, errorMessage }) => (
        <RegionSelector
          {...props}
          required={isRequired}
          errorMessage={errorMessage}
          region={(value as SearchSelectOption) ?? { key: 0, value: '' }}
          setRegion={onChange}
        />
      )}
    />
  )
}

